import client from './client';
export const locationsAPI = {
    async listCountries(query = '') {
        const response = await client.get('/locations/countries', { params: { query } });
        return response.data.data || [];
    },
    async listRegions(country, query = '') {
        const response = await client.get('/locations/regions', { params: { country, query } });
        return response.data.data || [];
    },
    async listCities(country, region, query = '') {
        const response = await client.get('/locations/cities', { params: { country, region, query } });
        return response.data.data || [];
    },
};
